import React, { useEffect, useState } from "react";
import * as R from "ramda";
import * as utils from "utils";
import { useSettings } from "utils/settingsContext";
import kountSDK from "@kount/kount-web-client-sdk";

const pre = "[KOUNT:WebSDK]";

const getRawHostname = (hostname) =>
  R.startsWith("http", hostname) ? new URL(hostname).hostname : hostname;

const getKountData = (integratorSettings, onComplete, sessionId, debug) => {
  const kountData = {
    config: {
      clientID: R.path(["kount", "clientID"], integratorSettings),
      hostname: getRawHostname(R.path(["kount", "hostname"], integratorSettings)),
      isSinglePageApp: true,
      isDebugEnabled: debug,
      callbacks: {
        "collect-end": onComplete,
      },
    },
    sessionId,
  };
  return kountData;
};

export const WebSDK = ({
  onComplete = utils.noop,
  onError = utils.noop,
}) => {
  const { debug, sessionCtx, sessionId } = utils.useSessionCtx();
  const { integratorSettings } = useSettings();
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (utils.isNilOrEmpty(integratorSettings)) return;

    try {
      const handleComplete = (data) => {
        debug(pre, "handleComplete", data);
        setComplete(true);
        onComplete(data);
      };

      const kountData = getKountData(
        integratorSettings,
        handleComplete,
        sessionId,
        sessionCtx.debug
      );
      debug(pre, "kountData: ", kountData);
      kountSDK(kountData.config, kountData.sessionId);
    } catch (e) {
      debug(pre, "Kount SDK error", e.message);
      onError(`Kount SDK error: ${e.message}`);
      setComplete(true);
    }
  }, [debug, onComplete, onError, sessionCtx.debug, sessionId, integratorSettings]);

  return (
    <>
      {complete && <span data-testid="k-complete" />}
    </>
  );
};
